<script>
	import Router from 'svelte-spa-router';
	import routes from './routes';
	import { onMount} from 'svelte';
	import { initMonitor, keepStoreInSync } from './service/PersistStore.js';
	import { AppAccessGranted, UserToken } from './stores/LoggedUser.js'

	onMount(async () => {
		console.log('Mounti the main app container');
		initMonitor();
		keepStoreInSync();
		if( !$AppAccessGranted ){
			window.location.href = '#/';
		} else if( $UserToken == '' ){
			window.location.href = '#/login';
		}
	});

	window.onresize = function() {
		document.body.height = window.innerHeight;
		console.log(document.body.height);
	}
	window.onresize(); // called to initially set the height.

</script>

<main class="rpgui-content rpgui-cursor-default">
	<div class="app_content">
		<Router {routes} />
	</div>
</main>